import _ from 'lodash';

import {
  FETCH_UNIVERSITIES,
  FETCH_UNIVERSITIES_SUCCESS,
  FETCH_UNIVERSITIES_FAIL,
} from '../../config/constants/actionTypes';

export const INITIAL_STATE = {
  byID: {},
  browse: {
    IDs: [],
    start: 0,
    end: 10,
    totalPages: 1,
    loading: false,
    error: '',
    count: 0,
  },
};

const setBrowse = (state, { type, payload }) => {
  switch(type) {
    case FETCH_UNIVERSITIES:
      return { ...state, loading: true, error: '' };
    case FETCH_UNIVERSITIES_SUCCESS:
      return {
        ...state,
        IDs: _.map(payload.data, m => m._id),
        start: payload.start,
        end: payload.end,
        count: payload.count,
        loading: false,
        error: ''
      };
    case FETCH_UNIVERSITIES_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };
    default:
      return state;
  }
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case FETCH_UNIVERSITIES:
      return {
        ...state,
        browse: setBrowse(state.browse, action),
      };
    case FETCH_UNIVERSITIES_SUCCESS:
      return {
        ...state,
        byID: _.keyBy(action.payload.data, '_id'),
        browse: setBrowse(state.browse, action),
      };
    case FETCH_UNIVERSITIES_FAIL:
      return {
        ...state,
        browse: setBrowse(state.browse, action),
      };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/modules/universities/reducers.js